// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChevronRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12">
            <polygon
                fill="currentColor"
                points="1.241 0 1.718 .602 5.633 5.537 6 6 5.633 6.463 1.241 12 0 11.074 .477 10.472 4.024 6 .477 1.528 0 .926"
            />
        </svg>
    );
};

export default React.memo(ChevronRight);
